import { FC, useMemo } from 'react';
import { MultiSelectBaseCriteria } from './multi-select-base';
import { MultiUserFieldFilter } from '../../../../../types/filter-field/filter/multi-user';
import { UserEditorComponents } from '../../field-editors/default-editor-components';
import { EditorComponents } from '../../field-editors/types';
import { UserOptionsGetter } from '../types';

interface Props {
  filter: MultiUserFieldFilter;
  optionsGetter?: UserOptionsGetter;
  onChange: (filter: MultiUserFieldFilter) => void;
  components?: EditorComponents;
  show?: number;
}

export const MultiUserCriteria: FC<React.PropsWithChildren<Props>> = ({
  filter,
  onChange,
  optionsGetter,
  components,
  show,
}) => {
  const options = useMemo(
    () =>
      optionsGetter != null
        ? optionsGetter(filter.field)
        : (filter.field.metaData.options ?? []),
    [filter.field, optionsGetter],
  );

  return (
    <MultiSelectBaseCriteria
      components={{
        ...UserEditorComponents,
        ...components,
      }}
      filter={filter}
      onChange={onChange as any}
      options={options}
      show={show}
      type="user"
    />
  );
};
